import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper";
import {
    getBookmarkPresentations,
    getBookmarkPresentationsByID,
    getBookmarkPresentationsFilterFormsByBookmarkPresentation, getLayerByName
} from "@/helpers/ol/ol-layer-helper";
import {updateLanguage} from "@/modules/language/language";
import {initLayerStylePicker} from "@/helpers/layer-style-picker-helper";
import {initHideButton, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {generateMetaDataHtml} from "@/helpers/meta-data-helper";
import {
    addClassByElement,
    getBySelector, hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {getTemporaryLayerByIndex} from "@/helpers/layer/temporary/temporary-layer-helper";
import {setLayerByViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";
import {getLegendUrlByBookmarkPresentation} from "@/helpers/layer/info/layer-info-legend-helper";

let loaded = false

export function isInfoCharacteristicsLoaded() {
    return loaded
}

export function loadInfoCharacteristics(bookmarkPresentationID, showInfoCharacteristics = true) {

    window.activeCharacteristicsBookmarkID = bookmarkPresentationID
    window.bootstrapSliders = []

    loaded = true

    let bookmarkPresentation

    let isMerged = false
    if(bookmarkPresentationID) {
        isMerged = bookmarkPresentationID.toString().includes('merged-')
    }

    // Temporary layer
    if(bookmarkPresentationID && bookmarkPresentationID.toString().includes('temporary-')) {
        const temporaryLayer = getTemporaryLayerByIndex(bookmarkPresentationID)

        bookmarkPresentation = {}
        bookmarkPresentation.MetaData = []
        bookmarkPresentation.Opacity = 10
        bookmarkPresentation.ID = bookmarkPresentationID
        bookmarkPresentation.BookmarkPresentationID = bookmarkPresentationID
        bookmarkPresentation.Styles = []

        if(temporaryLayer.Styles) {
            temporaryLayer.Styles.map(style => {
                bookmarkPresentation.Styles.push(style.Name)
            })
        }

        bookmarkPresentation.DisplayName = temporaryLayer.Name
    }

    let bookmarkPresentations = []
    // Merged layer

    if(typeof bookmarkPresentationID === 'string' && bookmarkPresentationID.includes(',')) {
        bookmarkPresentationID.split(',').map(bookmarkPresentationID => {
            const bookmarkPresentationTemp = getBookmarkPresentationsByID(bookmarkPresentationID)

            console.log(bookmarkPresentationTemp, bookmarkPresentationID)

            if(bookmarkPresentationTemp) {
                bookmarkPresentation = bookmarkPresentationTemp
                bookmarkPresentations.push(bookmarkPresentation)
            }
        })
    } else {
        if(bookmarkPresentationID && bookmarkPresentationID.toString().includes('merged-')) {
            const mergedItem = bookmarkPresentationID.replace('merged-', '').split('-')

            window.branchMerged[mergedItem[1]][mergedItem[0]].branch.map(branch => {
                bookmarkPresentation = getBookmarkPresentationsByID(branch.ID)
                if(bookmarkPresentation) {
                    bookmarkPresentations.push(bookmarkPresentation)
                }
                if(branch.branch) {
                    branch.branch.map(branchItem => {
                        bookmarkPresentation = getBookmarkPresentationsByID(branchItem.ID)
                        if (bookmarkPresentation) {
                            bookmarkPresentations.push(bookmarkPresentation)
                        }
                    })
                }
            })
        } else {
            if(!bookmarkPresentation) {
                bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)
                if (!bookmarkPresentation) {
                    clearInfoCharacteristics()
                    return
                }
            }

            bookmarkPresentations.push(bookmarkPresentation)
        }
    }

    window.activeCharacteristicsBookmarkPresentations = bookmarkPresentations

    let innerHtml = ``

    innerHtml += `<div class="card m-3 bg-lighter layer-info-card" style="border-radius: 10px;">
            <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
                <h2><span class="fa fa-tag title-icon"></span> Kenmerken 
                <button title="Sluiten" class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-characteristics">
                    <span class="fa fa-times"></span>
                </button>
                <button title="Minimaliseren" class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                    <span class="fa fa-minus"></span>
                </button>
                </h2>
            </div>
         <div class="info-card-body">
    
        <div class="card mt-2 ml-2 mr-2 d-none">
            <div class="card-body pl-2 pt-1 pr-2 pb-1">
                    <div class="row">
                        <div class="col-6">
                            <div class="mt-1">Laag</div>
                        </div>
                        <div class="col-6">
                            <layer-info-characteristics-layer-select data-id="` + bookmarkPresentation.ID + `" ></layer-info-characteristics-layer-select>
                        </div>
                    </div>   
                </div>
            </div>
`

    innerHtml += `
           <div class="cover pl-2">
                    <div class="nav nav-tabs scrollmenu">`
    bookmarkPresentations.map((bookmarkPresentation, key) => {
        let active = ''
        if(key === 0) {
            active = 'active'
        }

        innerHtml += `<li class="nav-item">
          <a class="nav-link nav-link-characteristics ${active}" data-id="${bookmarkPresentation.ID}" href="#Info">${bookmarkPresentation.DisplayName}</a>
        </li>`
    })

    innerHtml +=
        `</div>
            </div>`

    bookmarkPresentations.map((bookmarkPresentation, key) => {

        let visible = ''
        if(key > 0) {
            visible = 'd-none'
        }

        let hasNoForms = ''
        if(bookmarkPresentation.Forms && bookmarkPresentation.Forms.length > 0) {
            hasNoForms = 'd-none'
        }

        let hasNoRights = ''
        if(!bookmarkPresentation.HasInfo) {
            hasNoRights = 'maar er zijn onvoldoende rechten om de administratieve gegevens te tonen'
        }

        innerHtml += `<div class="nav-tab-characteristics ${visible}" data-id="${bookmarkPresentation.ID}">`

        // if(bookmarkPresentation.MetaData.length > 0 && ['WMS', 'WFS'].includes(bookmarkPresentation.Type) && !isMerged && !window.settings.IsSecured) {

        if(bookmarkPresentation.PortalBookmarkPresentation) {

            const portalBookmarkPresentation = bookmarkPresentation.PortalBookmarkPresentation

            let apiName = portalBookmarkPresentation.presentation.ApiName
            if(!apiName) {
                apiName = portalBookmarkPresentation.presentation.DisplayName
            }

            innerHtml += `
                <div class="card m-2">
                    <div class="card-body p-2">
                        <span class="font-weight-bold">Data weergave</span>
                        <div class="mt-1">`
            innerHtml += `<a href="` + window.kaartViewerUrl + `/portaal/index.html?website=${portalBookmarkPresentation.bookmark_group.bookmark.Naam}&dataset=${apiName}&page=dataset" target="dataportaal" class="btn btn-sm btn-outline-secondary"><span class="fa fa-edit"></span>
                           Open in dataportaal
                         </a>`

            innerHtml += `</div>
                     </div>
                </div>`
        }

        let zIndex = ''

        innerHtml += `

        

                <div class="card ml-2 mr-2 mt-2">
                    <div class="card-header p-2">
                        <a href="#" data-bs-target="#collapse-layer-options${bookmarkPresentation.ID}" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse"
                           aria-expanded="true">
                            Laagopties
                            <div class="collapse-icon float-right"></div>
                        </a>
                        <div id="collapse-layer-options${bookmarkPresentation.ID}" class="collapse show pb-2 pt-1">
                            <table class="table table-borderless mb-0">
                                <tr>
                                    <th class="w-50 pl-0">
                                        Transparantie
                                    </th>
                                    <td>
                                        <div class="slider-primary pl-2 pr-2">
                                            <input
                                                id="slider${bookmarkPresentation.ID}"
                                                class="bs-slider-variant"
                                                type="text"
                                                name="somename"
                                                data-provide="slider"
                                                data-slider-min="0"
                                                data-slider-max="100"
                                                data-slider-step="1"
                                                data-slider-value="` + bookmarkPresentation.Opacity * 10 + `"
                                                data-slider-tooltip="hide"
                                            ></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="w-50 pl-0">
                                        Volgorde
                                    </th>
                                    <td>
                                        <layer-info-characteristics-layer-index data-bookmark-presentation-id="${bookmarkPresentation.BookmarkPresentationID}" data-direction="first" data-icon="angle-double-up"></layer-info-characteristics-layer-index>
                                        <layer-info-characteristics-layer-index data-bookmark-presentation-id="${bookmarkPresentation.BookmarkPresentationID}" data-direction="up" data-icon="angle-up"></layer-info-characteristics-layer-index>
                                        <layer-info-characteristics-layer-index data-bookmark-presentation-id="${bookmarkPresentation.BookmarkPresentationID}" data-direction="down" data-icon="angle-down"></layer-info-characteristics-layer-index>
                                        <layer-info-characteristics-layer-index data-bookmark-presentation-id="${bookmarkPresentation.BookmarkPresentationID}" data-direction="latest" data-icon="angle-double-down"></layer-info-characteristics-layer-index>
                                   </td>
                                </tr>
                                <tr>
                                    <th class="w-50 pl-0">
                                        Centreren
                                    </th>
                                    <td>
                                        <div>
                                             <layer-menu-active-item-zoom data-label="${bookmarkPresentation.DisplayName}" data-id="${bookmarkPresentation.BookmarkPresentationID}"></layer-menu-active-item-zoom>
                                        </div>
                                     </td>
                                </tr>`

        if(bookmarkPresentation.MinResolution >= 0) {
            innerHtml += `   
                                <tr>
                                    <th class="w-50 pl-0">
                                        Schaal
                                    </th>
                                    <td>
                                        <div class="ml-2" >
                                            ${bookmarkPresentation.MinResolution} - ${bookmarkPresentation.MaxResolution}
                                            <layer-menu-active-item-zoom-scale data-id="${bookmarkPresentation.ID}" data-max-scale="${bookmarkPresentation.MaxResolution}" data-min-scale="${bookmarkPresentation.MinResolution}"></layer-menu-active-item-zoom-scale>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="w-50 pl-0">
                                        Bevraagbaar
                                    </th>
                                    <td>
                                        <div class="ml-2">
                                            Deze laag bevat <b class="${hasNoForms}">geen</b> administratieve gegevens ${hasNoRights}
                                        </div>
                                    </td>
                                </tr>
        `
        }

        if(bookmarkPresentation.Styles.length > 1) {
            innerHtml += `    
                                <tr>
                                    <th class="w-50 pl-0">
                                        Visualisatie
                                    </th>
                                    <td>
                                        <select id="slcLayerStylePicker-${bookmarkPresentation.ID}" size="1" class="custom-select mt-2">`

            bookmarkPresentation.Styles.map(style => {

                let selected = ''
                if(style === bookmarkPresentation.StyleActive) {
                    selected = 'selected="selected"'
                }

                innerHtml += `               <option ` + selected + `>` + style + `</option>`
            })
            innerHtml += `               </select>
                                     </td>
                                </tr>`
        }


        innerHtml += `     </table>
                        </div>
                    </div>
                </div>`

        if(bookmarkPresentation.Legend) {

            const legend = getLegendUrlByBookmarkPresentation(`#collapse-legend${bookmarkPresentation.ID} img`, bookmarkPresentation)

            innerHtml += `
                <div class="card ml-2 mr-2 mt-2">
                    <div class="card-header p-2">
                        <a href="#" data-bs-target="#collapse-legend${bookmarkPresentation.ID}" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse"
                           aria-expanded="true">
                            Legenda
                            <div class="collapse-icon float-right"></div>
                        </a>
                        <div id="collapse-legend${bookmarkPresentation.ID}" class="collapse show pb-2 pt-1">
                            <img src="` + legend + `">
                        </div>
                    </div>
                </div>`
        }

        const metaData = bookmarkPresentation.MetaData.filter(metaData => metaData.Name !== 'Aantallen in deze set' && metaData.Name !== 'Aantal keer bekeken t/m gisteren')
        if(metaData.length > 0) {
            innerHtml += `
                <div class="card ml-2 mr-2 mt-2" id="divMetaData">
                    <div class="card-header p-2">
                        <a href="#" data-bs-target="#collapse-metadata${bookmarkPresentation.ID}" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse"
                           aria-expanded="true">
                            Metadata
                            <div class="collapse-icon float-right"></div>
                        </a>
                        <div id="collapse-metadata${bookmarkPresentation.ID}" class="collapse show pb-2 pt-1">`;

            innerHtml += generateMetaDataHtml(metaData)

            innerHtml += `</div>
                </div>
            </div>`
        }

        if(bookmarkPresentation.MetaData.length > 0) {
            innerHtml += `
                <div class="card ml-2 mr-2 mt-2" id="divMetaData">
                    <div class="card-header p-2">
                        <a href="#" data-bs-target="#collapse-statistics${bookmarkPresentation.ID}" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse"
                           aria-expanded="true">
                            Aantallen en statistieken
                            <div class="collapse-icon float-right"></div>
                        </a>
                        <div id="collapse-statistics${bookmarkPresentation.ID}" class="collapse show pb-2 pt-1">`;

            innerHtml += generateMetaDataHtml(bookmarkPresentation.MetaData.filter(metaData => metaData.Name === 'Aantallen in deze set' || metaData.Name === 'Aantal keer bekeken t/m gisteren'))

            innerHtml += `</div>
                </div>
            </div>`
        }

        innerHtml += `</div>`
    })

    innerHtml += `</div>`


    const element = document.querySelector('layer-info-characteristics')
    element.innerHTML = innerHtml

    bookmarkPresentations.map(bookmarkPresentation => {
        initBoostrapSlider(`slider${bookmarkPresentation.ID}`, bookmarkPresentation.ID, bookmarkPresentations)
        initLayerStylePicker('slcLayerStylePicker', bookmarkPresentation)
    })

    initHideButton()

    updateLanguage()

    if(showInfoCharacteristics) {
        showLayerInfoButton('layer-info-characteristics', false)
    }

    getBySelector('layer-info-characteristics-button').querySelector('.info-menu-btn').classList.add('active')

    showElementsBySelector('layer-info-characteristics-button')
    setLayerByViewResolution()

    element.querySelectorAll('.nav-link-characteristics').forEach(element => {
        element.addEventListener('click', (event) => {
            removeClassBySelector('.nav-link-characteristics', 'active')
            addClassByElement(event.target, 'active')
            hideElementsBySelector('.nav-tab-characteristics')
            getBySelector('.nav-tab-characteristics[data-id="' + event.target.dataset.id + '"]').classList.remove('d-none')
        })
    })
}

export function clearInfoCharacteristics() {

    const innerHtml = `
    <div class="info-menu-info-header">
         <div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: 0 10px 10px 10px;;max-height: calc(100vh - 209px);overflow: auto;-webkit-overflow-scrolling: touch;">
          <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
             <h2>
             <span class="fa fa-tag title-icon"></span>
             <layout-language data-key="characteristics"></layout-language>
             <button title="Sluiten" class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                <span class="fa fa-times"></span>
             </button>
             </h2>
         </div>
          <div class="info-menu-info">
            <div class="card-body pl-2" style="margin-top:20px">
                <p>
                    Klik op <i class="fa fa-tag"></i> bij de catalogus voor de kenmerken
                </p>
            </div>
        </div>
        <div class="info-card-body d-none">
            <div class="card m-2">
                <div class="card-body p-2">
                    <div class="row">
                        <div class="col-6">
                            <div class="mt-1">Laag</div>
                        </div>
                        <div class="col-6">
                            <layer-info-characteristics-layer-select></layer-info-characteristics-layer-select>
                        </div>
                    </div>  
                 </div>
            </div>
        </div>
    </div>
    `;

    document.querySelector('layer-info-characteristics').innerHTML = innerHtml

    updateLanguage()

    const infoMenuButton = getBySelector('layer-info-characteristics-button').querySelector('.info-menu-btn')
    if(infoMenuButton) infoMenuButton.classList.remove('active')

    removeClassBySelector('.btn-characteristics', 'active')
}
